import { render } from "./BarcodeDetail.vue?vue&type=template&id=a21b9420&scoped=true"
import script from "./BarcodeDetail.vue?vue&type=script&lang=ts"
export * from "./BarcodeDetail.vue?vue&type=script&lang=ts"

import "./BarcodeDetail.vue?vue&type=style&index=0&id=a21b9420&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a21b9420"

export default script